import { UserUtils } from 'utils'
import {
  convertToScormTimeSpan,
  createRapidModuleLocation,
  getScorm12Status,
} from 'scorm/helpers/scormRuntimeHelper'
import { ScormRuntimeData, CoreEntry, IScormDataBuilder, CoreExit } from 'scorm/types'
import {
  StartRapidElearningAttemptData,
  RapidElearningChapter,
} from 'modules/activityDetails/RapidElearningDetails/types'

export default class RapidElearningScormDataBuilder implements IScormDataBuilder {
  private CoreChildren: string = `student_id,student_name,lesson_location,credit,
  lesson_status,entry,score,total_time,lesson_mode,exit,session_time`
  private Credit: string = 'credit'
  private ScoreChildren: string = 'raw'
  private LessonMode: string = 'normal'
  private StudentDataChildren: string = 'mastery_score'
  private Version: string = '3.4'

  constructor(
    private chapter: RapidElearningChapter,
    private attemptData: StartRapidElearningAttemptData,
    private courseId: Guid,
    private revision: number
  ) {}

  public build(): ScormRuntimeData {
    const { chapterScormData, successStatus, completionStatus, score, totalTime } = this.chapter
    const { launchData, masteryScore, scoLocation } = chapterScormData
    const { lessonLocation, number, coreExit, suspendData } = this.attemptData

    const scormLocation = createRapidModuleLocation(this.courseId, this.revision, scoLocation)
    const { login, name = '' } = UserUtils.getUserAccountInfo()

    const scormData: ScormRuntimeData = {
      CoreChildren: this.CoreChildren,
      Credit: this.Credit,
      ScoreChildren: this.ScoreChildren,
      LessonMode: this.LessonMode,
      StudentDataChildren: this.StudentDataChildren,
      Version: this.Version,

      StudentId: login,
      StudentName: name,

      // from existing result or definition
      ScormLocation: scormLocation,
      LessonStatus: getScorm12Status(completionStatus, successStatus),
      LaunchData: launchData || '',
      MasteryScore: masteryScore ? masteryScore.toString() : '',
      ScoreRaw: score ? score.toString() : '',
      TotalTime: convertToScormTimeSpan(totalTime),

      // from new attempt
      LessonLocation: lessonLocation,
      Entry: number > 1 ? CoreEntry.Resume : CoreEntry.AbInitio,
      Exit: CoreExit[coreExit],
      SuspendData: suspendData,
      SessionTime: '0000:00:00.00',
    }
    return scormData
  }
}
